import _default from './createPaginationItems';
export { _default as default };